"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AXSToggleGroup = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var styled_components_1 = __importDefault(require("styled-components"));
var Wrapper = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background: #007def;\n    background-clip: content-box;\n    border: 2px solid transparent;\n    border-radius: 10px;\n    margin: 12px 0;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #007def;\n    border-radius: 10px;\n  }\n  padding: 0px;\n  height: auto;\n  max-height: ", ";\n  & > .c-axs-block {\n    margin-right: 24px;\n  }\n"], ["\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background: #007def;\n    background-clip: content-box;\n    border: 2px solid transparent;\n    border-radius: 10px;\n    margin: 12px 0;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #007def;\n    border-radius: 10px;\n  }\n  padding: 0px;\n  height: auto;\n  max-height: ", ";\n  & > .c-axs-block {\n    margin-right: 24px;\n  }\n"])), function (props) { return props.height ? props.heihgt : '200px'; });
var AXSToggleGroup = /** @class */ (function (_super) {
    __extends(AXSToggleGroup, _super);
    function AXSToggleGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            items: [],
        };
        _this.setInitialState = function () {
            var items = [];
            React.Children.map(_this.props.children, function (child) {
                items.push(__assign(__assign({}, child.props), { enabled: child.props.enabled, value: child.props.value }));
            });
            _this.setState({ items: items });
        };
        _this.toggle = function (value, index) {
            var _a = _this.props, handleChange = _a.handleChange, forceSingleSelection = _a.forceSingleSelection;
            var items = __spreadArrays(_this.state.items);
            if (forceSingleSelection) {
                items.forEach(function (item) {
                    item.enabled = false;
                });
                items[index].enabled = true;
            }
            else {
                items[index].enabled = !items[index].enabled;
            }
            _this.setState(function () { return ({ items: items }); }, function () {
                var selections = items.map(function (item) {
                    return ({ value: item.value, label: item.label, enabled: item.enabled });
                });
                handleChange(selections, { value: value, enabled: items[index].enabled });
            });
        };
        return _this;
    }
    AXSToggleGroup.prototype.componentDidMount = function () {
        this.setInitialState();
    };
    AXSToggleGroup.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.children !== this.props.children) {
            this.setInitialState();
        }
    };
    AXSToggleGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, className = _a.className, children = _a.children;
        var childrenElements = React.Children.map(children, function (child, index) {
            var items = _this.state.items;
            return React.cloneElement(child, __assign(__assign({ onClick: function () { return _this.toggle(child.props.value, index); } }, child.props), { enabled: items && items.length > 0 && items[index].enabled, name: name }));
        });
        return React.createElement(Wrapper, __assign({ flexDirection: this.props.direction, justifyContent: "flex-start", className: classnames_1.default(['c-axs-toggle', className]) }, this.props), childrenElements);
    };
    AXSToggleGroup.defaultProps = {
        direction: 'row',
    };
    return AXSToggleGroup;
}(React.Component));
exports.AXSToggleGroup = AXSToggleGroup;
var templateObject_1;
//# sourceMappingURL=index.js.map